import React from 'react'
import ColoredButton from './ColoredButton'

const PrimaryButton = ({ className, ...otherProps }) => {
  return <ColoredButton color="primary" className={className} {...otherProps} />
}

export default PrimaryButton
